import { styled } from '../../../../../modules';

type Mode = 'info' | 'success' | 'away';

const modeTokens: Record<Mode, { background: string; borderColor: string; textColor?: string }> = {
    info: { background: '#EFF7FF', borderColor: '#3B94F614', textColor: '#3B94F6' },
    success: { background: '#EEFAF1', borderColor: '#CFF0D6', textColor: '#2CBB48' },
    away: { background: '#FFF9EB', borderColor: '#FFEEDB', textColor: '#FA7319' },
};

export const Box = styled.div<{ $mode: Mode }>`
    background-color: ${({ $mode }) => modeTokens[$mode].background};
    border-radius: 8px;
    border: 1px solid ${({ $mode }) => modeTokens[$mode].borderColor};
    padding: 12px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: flex-start;
`;

export const Content = styled.div`
    font-size: 14px;
    color: #4a5568;
    line-height: 1.5;

    a {
        color: #1652a1;
        text-decoration: underline;
    }
`;

export const Title = styled.h1<{ $mode: Mode }>`
    font-size: 14px;
    font-weight: 700;
    color: ${({ $mode }) => modeTokens[$mode].textColor || '#0e3573'};
    margin: 0;
    line-height: 1.5;
`;

export const Texts = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;